import React, { useState, useEffect } from 'react';
import { Button, Grid, Paper, Typography } from '@mui/material';
import PublicHeader from 'components/PublicHeader';
import IntlMessages from 'lngProvider/IntlMessages';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import FooterWrapper from 'components/Footer';
import SignInService from 'services/SignInService';
import { styled } from '@mui/material/styles';
import { getPaperStyleObject } from 'styles/Paper';
import useQueryParams from 'hooks/useQueryParams';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
        return {
            ...paperStyle.root
        };
    });

const ForgotPasswordConfirmation = () => {
    const [loginConfig, setLoginConfig] = useState(null);
    const [redirectUri, setRedirectUri] = useState();
    const { getQueryParamByName } = useQueryParams();

    useEffect(() => {
        const fetchData = () => {
            const returnUrl = getQueryParamByName('ReturnUrl');
            let redirectUrl = getQueryParamByName('redirect_uri');
            let clientId = getQueryParamByName('client_id');
            let uiUri = getQueryParamByName('ui_uri');

            // If the client is a plugin, then use the UI URI for the redirect
            if (clientId && clientId === 'vasplugin' && uiUri) {
                redirectUrl = uiUri
                    .replace(new RegExp(/%3A/, 'g'), ':')
                    .replace(new RegExp(/%2F/, 'g'), '/');
            } else if (redirectUrl) {
                // If there is a provided redirect uri, use it
                redirectUrl = redirectUrl.replace(new RegExp(/%3A/, 'g'), ':')
                    .replace(new RegExp(/%2F/, 'g'), '/')
                    .replace('/app/login-callback', '');
            }

            setRedirectUri(redirectUrl);

            SignInService.getLogInConfig(returnUrl).then(data => setLoginConfig(data));
        };

        fetchData();
    }, [getQueryParamByName]);

    document.title = "3M - Forgot Password Confirmation";


    const handleClick = () => {
        window.location.href = redirectUri;
    }

    return (
        <section>
            {loginConfig && loginConfig.showPublicHeader === true ?
                <PublicHeader />
                : ''}
            <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="center" direction="column">
                        <Grid item xs={12}>
                            <StyledPaper>
                                <Grid container alignItems="center" justifyContent="center" direction="column" spacing={4}>
                                    <Grid item xs={12}>

                                        <div className="text-success text-center"><CheckCircleTwoToneIcon fontSize="large" color="inherit" /></div>
                                        <Typography variant="h4" className="mt-4"><IntlMessages id="forgotPasswordConfirmation.emailSent" /></Typography>
                                        <Typography variant="subtitle2" className="mt-2"><IntlMessages id="forgotPasswordConfirmation.checkYourInbox" /></Typography>

                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            onClick={handleClick}>
                                            <IntlMessages id="forgotPasswordConfirmation.goBackToHomePage" />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </StyledPaper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FooterWrapper />
        </section>
    );
};

export default ForgotPasswordConfirmation;